import { Request, PODCASTERS_SERVICE } from '../Request/';
import { stringify as qsStringify } from 'query-string';
import moment from 'moment';

export async function getEpisodesForTrailerSelection(
  podcastId: string,
  page: number,
  shortEpisodesOnly: boolean,
  filter?: string,
  sortBy?: string,
  sortOrder?: string,
) {
  const params = qsStringify({
    start: '2015-05-01',
    end: moment().format('YYYY-MM-DD'),
    filter,
    maxDuration: shortEpisodesOnly ? 300000 : undefined,
    page,
    size: 50,
    includeStats: false,
    sortBy,
    sortOrder,
  });

  const data = await Request.of().get(
    `${PODCASTERS_SERVICE}/v0/shows/${podcastId}/episodes?${params}`,
  );

  return data.json();
}

export async function updateTrailer(
  podcastId: string,
  newTrailerId: string,
  previousTrailerId?: string,
) {
  return Request.of().put(`${PODCASTERS_SERVICE}/v0/shows/${podcastId}/metadata`, {
    trailer: { id: newTrailerId, previousId: previousTrailerId },
  });
}

export async function deleteTrailer(podcastId: string, trailerId: string) {
  return Request.of().delete(`${PODCASTERS_SERVICE}/v0/shows/${podcastId}/trailer`, {
    previousId: trailerId,
  });
}
